<template>
  <div
    class="ws-content"
    :style="{'min-height':minHeight}"
  >
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    minHeight: {
      type: String,
      default: null
    }
  }
};
</script>

<style lang="scss">
@import "../assets/scss/ws-content.scss";
</style>